import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getCollections } from "store/actions";
import { useSelector, useDispatch } from "react-redux";

export default function Collection(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isHide } = props;

  let profile = useSelector((state) => state);
  const collections = useSelector((state) => state?.collections);
  const [showCol, setShowCol] = useState([]);

  const [filter, setfilter] = useState({
    limit: 4,
    orderBy: "",
    order: "",
    page: 1,
    author: profile?.Profile?.userProfile?._id,
    isMore: false,
  });

  useEffect(() => {
    if (collections?.collections) {
      if (filter.isMore) {
        setShowCol((prevState) => [...prevState, ...collections?.collections]);
      } else {
        setShowCol(collections?.collections);
      }
    }
  }, [collections?.collections]);

  // useEffect(() => {
  //   if (profile?.Profile?.userProfile?._id) {
  //     setfilter((prevState) => ({
  //       ...prevState,
  //       author: profile?.Profile?.userProfile?._id,
  //       page: 1,
  //     }));
  //   }
  // }, [profile?.Profile?.userProfile?._id]);

  // useEffect(() => {
  //   if (filter?.author) {
  //     // dispatch(getCollections(filter));
  //   }
  // }, [filter]);

  const showMoreItems = (evt) => {
    evt.preventDefault();
    setfilter((prevState) => ({
      ...prevState,
      page: prevState.page + 1,
      isMore: true,
    }));
  };

  const Redirect = () => {
    const GetAddress = localStorage.getItem("walletAddress");
    if (GetAddress) {
      navigate("/create-collection");
    } else {
      navigate("/metamask-sign");
    }
  };

  return (
    <section className="Collection-main">
      <Container>
        {!isHide && (
          <div className="create-collection-head">
            <h2>Collections </h2>
            <Button className="create-collectionbtn" onClick={Redirect}>
              + Create Collection
            </Button>
          </div>
        )}

        <Row>
          {showCol && showCol?.length > 0 ? (
            <>
              {showCol?.map((item, idx) => {
                return (
                  <Col key={idx} lg={4} md={6} sm={12}>
                    <Link
                      to={`/card-profile?id=${item?.contractAddress}`}
                      className="collection-col"
                    >
                      <div className="profile-card">
                        <div className="profile-card-img position-relative">
                          <img
                            src={item?.image?.link}
                            alt="collection-image"
                            className="img-fluid"
                          />
                        </div>
                        <div className="collection-card-content">
                          <h4>{item?.name}</h4>
                        </div>
                      </div>
                    </Link>
                  </Col>
                );
              })}
            </>
          ) : (
            <div className="mt-2 w-100">
              <h5 className="collect-head">Collections Not Found !!</h5>
            </div>
          )}
        </Row>

        {showCol?.length < collections?.totalCollections && (
          <div className="text-center show-wrap">
            <button
              onClick={showMoreItems}
              type="button"
              className="showmore btn btn-primary"
            >
              Show Me More
            </button>
          </div>
        )}
      </Container>
    </section>
  );
}
